// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import { Button, Loader, Icon, Image } from 'semantic-ui-react'
// import fire from '../firebase'
import html2canvas from 'html2canvas'

import WaveSurfer from 'wavesurfer.js'
export default class Build extends Component {
  constructor (props) {
    super(props)
    this.state = {
      loading: true,
      sound: null,
      url: '',
      progress: 0,
      uploaded: false,
      ready: true,
      waveModal: false,
      playing: false
    }
  }

  componentDidMount = () => {
    this.setState(
      {
        loggedIn: true
      },
      function () {
        if (this.props.location.state.url) {
          this.mountWave()
        } else {
          this.mountWaveRecord()
        }
      }
    )
  }

  mountWave () {
    const self = this
    this.wavesurfer = WaveSurfer.create({
      waveColor: this.props.location.state.wave,
      progressColor: this.props.location.state.wave,
      cursorColor: '#ddd',
      barWidth: 2,
      barHeight: 1,
      barGap: 3,
      cursorWidth: 2,
      container: '#waveform',
      height: 200,
      skipLength: 5,
      responsive: true
    })
    this.wavesurfer.load(this.props.location.state.url)
    this.wavesurfer.on('ready', function () {
      self.setState({ loading: false })
    })
  }

  mountWaveRecord () {
    const self = this
    this.wavesurfer = WaveSurfer.create({
      waveColor: this.props.location.state.wave,
      barWidth: 2,
      barHeight: 1,
      barGap: 3,
      cursorWidth: 2,
      container: '#waveform',
      height: 200,
      progressColor: '#ddd',
      cursorColor: '#ddd',
      skipLength: 5,
      responsive: true
    })
    this.wavesurfer.load(this.props.location.state.recordedBlob)
    this.wavesurfer.on('ready', function () {
      self.setState({ loading: false })
    })
  }

  playTrack = () => {
    this.wavesurfer.playPause()
    this.setState({ playing: !this.state.playing })
  }

  skipBackward = () => {
    this.wavesurfer.skipBackward()
  }
  skipForward = () => {
    this.wavesurfer.skipForward()
  }

  captureWave = () => {
    window.scrollTo(0, 0)
    setTimeout(function () {
      html2canvas(document.querySelector('#waveform')).then(function (canvas) {
        var dataURL = canvas.toDataURL('image/png')
        window.document.write('<img src="' + dataURL + '"/>')
      })
    }, 250)
  }
  render () {
    let { url, loading, playing, imageData } = this.state
    return (
      <div className='div1'>
        <div className='div3'>
          <br />
          <Loader active={loading} inline>
            Processing ...
          </Loader>
          {!loading && !playing && (
            <Button icon onClick={this.playTrack}>
              <Icon name='play' />
              Play
            </Button>
          )}
          {!loading && playing && (
            <Button icon onClick={this.playTrack}>
              <Icon name='pause' />
              Pause
            </Button>
          )}
          {!loading && <Button onClick={this.skipBackward}>Backward</Button>}
          {!loading && <Button onClick={this.skipForward}>Forward</Button>}
          <div
          style={{
            marginTop: 10,
            width: 600,
            height: 200,
            backgroundColor: this.props.location.state.bg
          }}
          id='waveform'
        >
          <audio id='song' src={url} />
        </div>
          {!loading && (
            <div>
              <br />
              <Button download color='facebook' onClick={this.captureWave}>
                Download
              </Button>
              <Image source={{ uri: `data:image/png;base64,${imageData}` }} />
            </div>
          )}
        </div>
      </div>
    )
  }
}
